
import {Parceiro} from '@/soganhei'

import http from '@/http/service'

export default function SalvarParceiro(payload=Parceiro){
 
    if(payload.idParceiro == undefined){
        return http.post("/admin/parceiros",payload)
    }else{
        return http.put(`/admin/parceiros/${payload.idParceiro}`,payload)
    }

}